<template>
  <div>
    <EvaluationHead v-if="!wholeSectionMasked()"/>
    <tbody v-if="section != undefined">

      <tr>
        <th class="titre" style="border-top:none;" colspan="16">
          {{ $t(title + section.id) }}
        </th>
      </tr>

      <tr v-for="(entry, index) in section.children"
          v-if="!isMasked(entry)"
          :key="index">
        <th class="title">
          {{ $t(title + entry.id) }}
          <div v-if="typeof errors[index] !== 'undefined'">
            <ul class="text-danger">
              <li v-for="(error, i) in errors[index]" :key="i">{{ error.message }}</li>
            </ul>
          </div>
        </th>

        <td class="step1 sticktop">
          <label class="container">
            <input v-model="step1.value[index]"
                   :value="value(entry, 'done',1)"
                   :ref="'step1-done-' + index"
                   type="radio"
                   @change="onChange($event, index)">
            <span class="checkmark"/>
          </label>
        </td>
        <td class="step1 lights1 sticktop">
          <label class="container">
            <input v-model="step1.value[index]"
                   :value="value(entry, 'not',1)"
                   :ref="'step1-not-' + index"
                   type="radio"
                   @change="onChange($event, index)">
            <span class="checkmark"/>
          </label>
        </td>
        <td class="step1 withborder sticktop">
          <label class="container">
            <input v-model="step1.value[index]"
                   :value="value(entry, 'na',1)"
                   :ref="'step1-na-' + index"
                   type="radio"
                   @change="onChange($event, index)">
            <span class="checkmark"/>
          </label>
        </td>

        <td class="step21 sticktop">
          <label class="container2">
            <input v-model="step2.helpType.technicalHelp[index]"
                   :ref="'step2-technicalHelp-' + index"
                   :disabled="!isInputEnabled('step2', index)"
                   type="checkbox"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step2', index) ? 'checkmark2 disabled' : 'checkmark2'"/>
          </label>
        </td>
        <td class="step21 lights2 withborder sticktop">
          <label class="container2">
            <input v-model="step2.helpType.amenagement[index]"
                   :ref="'step2-amenagement-' + index"
                   :disabled="!isInputEnabled('step2', index)"
                   type="checkbox"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step2', index) ? 'checkmark2 disabled' : 'checkmark2'"/>
          </label>
        </td>

        <td class="step22 sticktop">
          <label class="container">
            <input v-model="step2.helpType.value[index]"
                   :value="value(entry, 'no_help',1)"
                   :ref="'step2-helpType-no_help-' + index"
                   :disabled="!isInputEnabled('step2', index)"
                   type="radio"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step2', index) ? 'checkmark disabled' : 'checkmark'"/>
          </label>
        </td>

        <td class="step22 lights2 sticktop">
          <label class="container">
            <input v-model="step2.helpType.value[index]"
                   :value="value(entry, 'light',1)"
                   :ref="'step2-helpType-light-' + index"
                   :disabled="!isInputEnabled('step2', index)"
                   type="radio"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step2', index) ? 'checkmark disabled' : 'checkmark'"/>
          </label>
        </td>
        <td class="step22 sticktop">
          <label class="container">
            <input v-model="step2.helpType.value[index]"
                   :value="value(entry, 'heavy',1)"
                   :ref="'step2-helpType-heavy-' + index"
                   :disabled="!isInputEnabled('step2', index)"
                   type="radio"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step2', index) ? 'checkmark disabled' : 'checkmark'"/>
          </label>
        </td>
        <td class="step22 lights2 withborder sticktop">
          <label class="container">
            <input v-model="step2.helpType.value[index]"
                   :value="value(entry, 'full',1)"
                   :ref="'step2-helpType-full-' + index"
                   :disabled="!isInputEnabled('step2', index)" type="radio"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step2', index) ? 'checkmark disabled' : 'checkmark'"/>
          </label>
        </td>

        <td class="step23 sticktop">
          <label class="container">
            <input v-model="step2.difficultyLevel.value[index]"
                   :value="value(entry, 'low',1)"
                   :ref="'step2-difficultyLevel-low-' + index"
                   :disabled="!isInputEnabled('step2', index)"
                   type="radio"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step2', index) ? 'checkmark disabled' : 'checkmark'"/>
          </label>
        </td>
        <td class="step23 lights2 sticktop">
          <label class="container">
            <input v-model="step2.difficultyLevel.value[index]"
                   :value="value(entry, 'medium',1)"
                   :ref="'step2-difficultyLevel-medium-' + index"
                   :disabled="!isInputEnabled('step2', index)"
                   type="radio"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step2', index) ? 'checkmark disabled' : 'checkmark'"/>
          </label>
        </td>
        <td class="step23 withborder sticktop">
          <label class="container">
            <input v-model="step2.difficultyLevel.value[index]"
                   :value="value(entry, 'heavy',1)"
                   :ref="'step2-difficultyLevel-heavy-' + index"
                   :disabled="!isInputEnabled('step2', index)"
                   type="radio"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step2', index) ? 'checkmark disabled' : 'checkmark'"/>
          </label>
        </td>

        <td class="step3 sticktop">
          <label class="container">
            <input v-model="step3.value[index]"
                   :value="value(entry, 'really_satisfied',1)"
                   :ref="'step3-really_satisfied-' + index"
                   :disabled="!isInputEnabled('step3', index)"
                   type="radio"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step3', index) ? 'checkmark disabled' : 'checkmark'"/>
          </label>
        </td>
        <td class="step3 lights3 sticktop">
          <label class="container">
            <input v-model="step3.value[index]"
                   :value="value(entry, 'satisfied',1)"
                   :ref="'step3-satisfied-' + index"
                   :disabled="!isInputEnabled('step3', index)"
                   type="radio"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step3', index) ? 'checkmark disabled' : 'checkmark'"/>
          </label>
        </td>
        <td class="step3 sticktop">
          <label class="container">
            <input v-model="step3.value[index]"
                   :value="value(entry, 'unsatisfied',1)"
                   :ref="'step3-unsatisfied-' + index"
                   :disabled="!isInputEnabled('step3', index)"
                   type="radio"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step3', index) ? 'checkmark disabled' : 'checkmark'"/>
          </label>
        </td>
        <td class="step3 lights3 withborder sticktop">
          <label class="container">
            <input v-model="step3.value[index]"
                   :value="value(entry, 'really_unsatisfied',1)"
                   :ref="'step3-really_unsatisfied-' + index"
                   :disabled="!isInputEnabled('step3', index)"
                   type="radio"
                   @change="compute(index)">
            <span :class="!isInputEnabled('step3', index) ? 'checkmark disabled' : 'checkmark'"/>
          </label>
        </td>
        <td class="score">
          {{ score(index) }}
        </td>
      </tr>

      <tr v-if="wholeSectionMasked()">
        <td colspan="18" class="title">{{ $t('evaluation.mask.section_masked') }}</td>
      </tr>
    </tbody>
  </div>
</template>

<script>

import EvaluationHead from './EvaluationHead'
import Calculations from '~/utils/Calculations'

export default {

  name: 'EvaluationSection',
  components: { EvaluationHead },

  mixins: [Calculations],

  props: {
    evaluation_title: { type: String },
    section: { type: Object }
  },

  data: () => ({

    step1: {
      value: []
    },
    step2: {
      helpType: {
        technicalHelp: [],
        amenagement: [],
        value: []
      },
      difficultyLevel: {
        value: []
      }
    },
    step3: {
      value: []
    },

    inputState: {
      step2: {},
      step3: {}
    },

    errors: []
  }),

  computed: {
    title () {
      return 'evaluations.entries.' + this.evaluation_title + '.titles.'
    }
  },

  mounted () {

  },

  methods: {
    value (entry, result) {
      return {
        id: entry.id,
        result: result
      }
    },

    score (index) {
      if (typeof this.scores[index] !== 'undefined') {
        return this.scores[index]
      }
      return ''
    },

    onChange (event, index) {
      this.onStep1Change(event, index)
      this.compute(index)
    },

    compute (index) {
      this.validate()
      this.computeScore(index)
    },

    isMasked (entry) {
      return entry.masked || this.section.masked
    },

    onStep1Change (event, index) {
      if (this.step1.value[index].result === 'done') {
        this.enableInputs(true, true, index)
      } else if (this.step1.value[index].result === 'not') {
        this.enableInputs(false, true, index)
        this.clearStep2(index)
      } else if (this.step1.value[index].result === 'na') {
        this.enableInputs(false, false, index)
        this.clearStep2(index)
        this.clearStep3(index)
      }
    },

    clearStep2 (index) {
      this.step2.difficultyLevel.value[index] = undefined
      this.step2.helpType.value[index] = undefined
      this.step2.helpType.amenagement[index] = false
      this.step2.helpType.technicalHelp[index] = false
    },

    clearStep3 (index) {
      this.step3.value[index] = undefined
    },

    enableInputs (bolStep2, bolStep3, index) {
      this.inputState.step2[index] = bolStep2
      this.inputState.step3[index] = bolStep3
    },

    isInputEnabled (step, index) {
      if (this.inputState.hasOwnProperty(step) && this.inputState[step].hasOwnProperty(index)) {
        return this.inputState[step][index]
      }
      return true
    },

    update () {
      this.$forceUpdate()
    },

    validate () {
      this.clearErrors()
      let success = true
      for (let index in this.section.children) {
        let entry = this.section.children[index]

        // we ignore masked entry
        if (this.isMasked(entry)) {
          continue
        }

        // validate the entry
        success = this.validateEntry(index) && success
      }
      return success
    },

    clearErrors () {
      this.errors = []
    },

    validateEntry (index) {
      let success = true
      let errors = []
      if (typeof this.step1.value[index] === 'undefined' || this.step1.value[index] === null) {
        errors.push({
          message: this.$t('evaluations.errors.realised')
        })
      } else if (this.step1.value[index].result === 'done') {
        // if done is checked then helpType, difficultyLevel and satisfactionLevel must have value

        let helpTypeError = this.__helpTypeError(index)
        if (typeof helpTypeError !== 'undefined' || helpTypeError === null) {
          errors.push(helpTypeError)
        }

        let difficultyLevelError = this.__difficultyLevelError(index)
        if (typeof difficultyLevelError !== 'undefined' || difficultyLevelError === null) {
          errors.push(difficultyLevelError)
        }

        let step3Error = this.__step3Error(index)
        if (typeof step3Error !== 'undefined' || step3Error === null) {
          errors.push(step3Error)
        }
      } else if (this.step1.value[index].result === 'not') {
        // if not is checked then only satisfactionLevel must have value

        let step3Error = this.__step3Error(index)
        if (typeof step3Error !== 'undefined' || step3Error === null) {
          errors.push(step3Error)
        }
      } else if (this.step1.value[index].result === 'na') {
        // if na is checked then the row dont need to have any value
      }

      if (errors.length > 0) success = false

      if (!success) {
        this.errors[index] = errors
      } else {
        this.errors[index] = undefined
      }

      return success
    },

    reset () {
      this.step1.value = []
      this.step2.helpType.technicalHelp = []
      this.step2.helpType.amenagement = []
      this.step2.helpType.value = []
      this.step2.difficultyLevel.value = []
      this.step3.value = []
      this.unlockInputs()
      this.computeAllScores()
      this.update()
    },

    unlockInputs () {
      for (let i = 0; i < this.section.children.length; i++) {
        this.enableInputs(true, true, i)
      }
    },

    wholeSectionMasked () {
      return this.section.masked
    },

    /**
     * Load the snapshot into the section
     *
     * @param snapshot
     */
    setSnapshot (snapshot) {
      this.setupStep1(snapshot.step1)
      this.setupStep2(snapshot.step2)
      this.setupStep3(snapshot.step3)
      this.computeAllScores()
    },

    /**
     * Load snapshot.step1
     *
     * @param step1
     */
    setupStep1 (step1) {
      this.checkStep1FromSnapshot(step1)
      for (let i = 0; i < this.section.children.length; i++) {
        this.step1.value[i] = step1.value[i]
      }
    },

    checkStep1FromSnapshot (step1) {
      for (let index = 0; index < this.section.children.length; index++) {
        if (step1.value[index] === null || typeof step1.value[index] === 'undefined') { continue }
        if (step1.value[index].result === 'done') {
          this.enableInputs(true, true, index)
        } else if (step1.value[index].result === 'not') {
          this.enableInputs(false, true, index)
        } else if (step1.value[index].result === 'na') {
          this.enableInputs(false, false, index)
        }
      }
    },

    /**
     * Load snapshot.step2
     *
     * @param step2
     */
    setupStep2 (step2) {
      for (let i = 0; i < this.section.children.length; i++) {
        this.step2.helpType.technicalHelp[i] = step2.helpType.technicalHelp[i]
        this.step2.helpType.amenagement[i] = step2.helpType.amenagement[i]
        this.step2.helpType.value[i] = step2.helpType.value[i]
        this.step2.difficultyLevel.value[i] = step2.difficultyLevel.value[i]
      }
    },

    /**
     * Load snapshot.step3
     *
     * @param step3
     */
    setupStep3 (step3) {
      for (let i = 0; i < this.section.children.length; i++) {
        this.step3.value[i] = step3.value[i]
      }
    },

    /***********************************************************
     * Private method
     ***********************************************************/

    __helpTypeError (index) {
      if (typeof this.step2.helpType.value[index] === 'undefined') {
        return {
          message: this.$t('evaluations.errors.helpType')
        }
      }
      return undefined
    },

    __difficultyLevelError (index) {
      if (typeof this.step2.difficultyLevel.value[index] === 'undefined') {
        return {
          message: this.$t('evaluations.errors.difficulty')
        }
      }
      return undefined
    },

    __step3Error (index) {
      if (typeof this.step3.value[index] === 'undefined') {
        return {
          message: this.$t('evaluations.errors.satisfaction')
        }
      }
      return undefined
    }
  }
}

</script>

<style scoped>
.titre {
  font-size: 20px;
}

td {
  text-align: center;
}

/* The container */
.container {
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border-radius: 50%;

}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: black;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 9px;
  left: 9px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}

.container input ~ .checkmark.disabled,
.container:hover input ~ .checkmark.disabled,
.container2 input ~ .checkmark2.disabled,
.container2:hover input ~ .checkmark2.disabled  {
  background-color: #ccc;
  cursor: default;
}

/*checkbox*/
.container2 {
  display: block;
  position: relative;
  padding-left: 0px;
  margin-bottom: 0px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-top: -4px
}

/* Hide the browser's default checkbox */
.container2 input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark2 {
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: #fff;

}

/* On mouse-over, add a grey background color */
.container2:hover input ~ .checkmark2 {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container2 input:checked ~ .checkmark2 {
  background-color: #000000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark2:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container2 input:checked ~ .checkmark2:after {
  display: block;
}

.title {
  font-weight: normal;
  font-size: 17px;
}

td.step1, td.step2, td.step3, td.score {
  border-color: white;
  font-size: 20px;
  font-weight: bold;
}

.withborder {
  border-right-style: solid;
  border-right-color: white;
}

.step1 {
  background-color: #bbced2;
}

.step21 {
  background-color: #9bdec0;
}

.step22 {
  background-color: #9bdec0;
}

.step23 {
  background-color: #9bdec0;
}

.step3 {
  background-color: #bbced2;
}

.lights1 {
  background-color: #d3e9ed;
}

.lights2 {
  background-color: #cae6da;
}

.lights3 {
  background-color: #d3e9ed;
}

.score {
  background-color: #ffffcc;
}

.sticktop {
  vertical-align: top !important ;
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/evaluation/EvaluationSection.vue